"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MENU : INDICATOR : STYLES --------------- ++++++++++ */


var _default = {
  menuindicator: {
    cursor: 'pointer',
    transition: _index.theme.animation.general('all'),
    '&:hover': {
      filter: 'brightness(85%)'
    }
  }
};
exports.default = _default;